var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertToast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.448725 5.94926C0.477117 2.65585 3.15497 0.000982298 6.4485 0.000982064L83.6562 0.000976562C77.0197 21.3092 66.2287 41.0095 52.097 58.001L6.05195 58.001C2.71802 58.001 0.0234305 55.2831 0.0521704 51.9493L0.448725 5.94926Z",
    fill: "#F27C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2037 0.000379959L6.00003 2.95292e-05C2.68631 1.32207e-05 3.15214e-06 2.68631 3.15214e-06 6.00003V52.001C3.15214e-06 55.3147 2.68629 58.001 6 58.001H46.4998C60.3028 41.0025 70.8015 21.1822 77.2037 0.000379959Z",
    fill: "#FCA66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5445 17.3827L14.3848 37.6913C14.1341 38.1256 14.0014 38.6181 14 39.1196C13.9986 39.6212 14.1285 40.1144 14.3768 40.5501C14.625 40.9859 14.983 41.349 15.4151 41.6034C15.8472 41.8577 16.3384 41.9945 16.8397 42H41.1592C41.6606 41.9945 42.1517 41.8577 42.5838 41.6034C43.0159 41.349 43.3739 40.9859 43.6222 40.5501C43.8704 40.1144 44.0003 39.6212 43.9989 39.1196C43.9975 38.6181 43.8649 38.1256 43.6142 37.6913L31.4544 17.3827C31.1985 16.9606 30.8381 16.6116 30.4081 16.3694C29.9781 16.1272 29.4929 16 28.9995 16C28.506 16 28.0208 16.1272 27.5908 16.3694C27.1608 16.6116 26.8005 16.9606 26.5445 17.3827Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5445 17.3827L14.3848 37.6913C14.1341 38.1256 14.0014 38.6181 14 39.1196C13.9986 39.6212 14.1285 40.1144 14.3768 40.5501C14.625 40.9859 14.983 41.349 15.4151 41.6034C15.8472 41.8577 16.3384 41.9945 16.8397 42H41.1592C41.6606 41.9945 42.1517 41.8577 42.5838 41.6034C43.0159 41.349 43.3739 40.9859 43.6222 40.5501C43.8704 40.1144 44.0003 39.6212 43.9989 39.1196C43.9975 38.6181 43.8649 38.1256 43.6142 37.6913L31.4544 17.3827C31.1985 16.9606 30.8381 16.6116 30.4081 16.3694C29.9781 16.1272 29.4929 16 28.9995 16C28.506 16 28.0208 16.1272 27.5908 16.3694C27.1608 16.6116 26.8005 16.9606 26.5445 17.3827Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.998 24.8473V32.0523",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.998 35.5392H29.0104",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertToast);
export default __webpack_public_path__ + "static/media/alertToast.75b235f48d8dbcb76a8b39a2095a58f4.svg";
export { ForwardRef as ReactComponent };